// components/BorrowTable.js
import React from "react";
import "../App.css";

export default function BorrowTable({
  aaveLoading,
  aaveError,
  sortedBorrowData,
  selectedAave,
  onReserveRowClick,
  onBorrowSort,
  borrowSortColumn,
  borrowSortDirection,
  parseAaveBorrowRate,
}) {
  return (
    <div className="borrow-div">
      <div className="btitle-div">
        Borrow
        <div className="fromAave">
          <span className="from">from</span>
          <img src="/aaveText.png" alt="aaveText" className="aavetext" />
        </div>
      </div>

      <div className="table-div">
        {aaveLoading && (
          <div className="loading-text">Loading Aave data...</div>
        )}
        {aaveError && (
          <div className="error-text">
            Error fetching Aave data: {aaveError}
          </div>
        )}
        {!aaveLoading && !aaveError && (
          <table className="data-table">
            <thead>
              <tr className="label-row">
                <th>Symbol</th>
                <th
                  onClick={() => onBorrowSort("borrow")}
                  className="sortable-col"
                >
                  APY
                  {borrowSortColumn === "borrow" && ` (${borrowSortDirection})`}
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedBorrowData.map((reserve) => {
                const decimalBorrow = parseAaveBorrowRate(reserve);
                const borrowPct = (decimalBorrow * 100).toFixed(2) + "%";
                const isSelected = selectedAave?.id === reserve.id;

                return (
                  <tr
                    key={reserve.id}
                    className={`data-row ${isSelected ? "selected-row" : ""}`}
                    onClick={() => onReserveRowClick(reserve)}
                  >
                    <td className="table-cell basset-cell">
                      <div className="basset-content">
                        <img
                          src={`/${reserve.symbol}.png`}
                          alt={reserve.symbol}
                          className="asset-logo"
                        />
                        <div className="protocol-cell">
                          <span className="asset-name">
                            {reserve.symbol || "N/A"}
                          </span>
                          <span className="protocol-name-sub">
                            Aave V3 Core Instance
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="bAPY-cell">{borrowPct}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
